export  function getMap(){
return `1,-52.1,-86.24,0,11002
1,-38.92,-77.82,0,11002
2,-42.55,-72.15,0,11002
2,-48.16,-75.75,0,11002
2,-50.99,-71.39,0,11002
2,-52.89,-72.67,0,11002
2,-50.09,-77.03,0,11002
2,-55.75,-80.61,0,11002
1,-59.07,-75.38,0,11001
1,-45.85,-66.92,0,11001
2,-49.46,-61.27,0,11001
2,-55.06,-64.88,0,11001
2,-57.85,-60.48,0,11001
2,-59.75,-61.71,0,11001
2,-57.01,-66.14,0,11001
2,-62.66,-69.7,0,11001
1,2.38,26.47,0,11003
1,15.61,34.91,0,11003
2,12,40.51,0,11003
2,6.36,36.92,0,11003
2,3.51,41.28,0,11003
2,1.6,40.02,0,11003
2,4.41,35.65,0,11003
2,-1.21,32.03,0,11003
1,-7.71,41.89,0,11004
1,5.57,50.4,0,11004
2,1.97,56.03,0,11004
2,-3.68,52.42,0,11004
2,-6.48,56.8,0,11004
2,-8.39,55.58,0,11004
2,-5.61,51.19,0,11004
2,-11.23,47.55,0,11004
1,-24.37,22.62,0,11005
1,-11.13,31.02,0,11005
2,-14.68,36.65,0,11005
2,-20.33,33.08,0,11005
2,-23.13,37.49,0,11005
2,-25.05,36.27,0,11005
2,-22.28,31.87,0,11005
2,-27.93,28.27,0,11005
1,-80.3,-88.9,0,12001
1,-67.8,-80.83,0,12001
2,-69.67,-77.98,0,12001
2,-70.51,-78.55,0,12001
2,-71.89,-76.46,0,12001
2,-78.4,-80.67,0,12001
2,-77.07,-82.78,0,12001
2,-82.21,-85.92,0,12001
1,-73.36,-99.72,0,12002
1,-60.83,-91.71,0,12002
2,-62.81,-88.9,0,12002
2,-63.67,-89.45,0,12002
2,-65.02,-87.35,0,12002
2,-71.53,-91.57,0,12002
2,-70.2,-93.67,0,12002
2,-75.24,-96.92,0,12002
1,-39.55,3.72,0,12003
1,-27.58,11.53,0,12003
2,-29.42,14.37,0,12003
2,-30.24,13.85,0,12003
2,-31.61,15.93,0,12003
2,-38.13,11.69,0,12003
2,-36.79,9.6,0,12003
2,-41.42,6.58,0,12003
1,-44.24,10.94,0,12004
1,-32.25,18.75,0,12004
2,-34.09,21.58,0,12004
2,-34.93,21.05,0,12004
2,-36.31,23.14,0,12004
2,-42.82,18.89,0,12004
2,-41.48,16.79,0,12004
2,-46.07,13.81,0,12004
1,-50.02,19.64,0,12005
1,-38.08,27.47,0,12005
2,-39.91,30.33,0,12005
2,-40.73,29.76,0,12005
2,-42.13,31.85,0,12005
2,-48.61,27.57,0,12005
2,-47.26,25.5,0,12005
2,-51.88,22.44,0,12005
1,-53.16,5.42,0,13001
3,-93.21,-87.33,0,13001
3,-93.66,-87.38,0,13001
3,-94.11,-87.43,0,13001
3,-94.55,-87.53,0,13001
3,-94.91,-87.61,0,13001
3,-95.32,-87.72,0,13001
3,-95.72,-87.89,0,13001
3,-96.13,-88.07,0,13001
3,-96.53,-88.27,0,13001
3,-96.96,-88.54,0,13001
3,-97.42,-88.87,0,13001
3,-97.78,-89.17,0,13001
3,-98.13,-89.48,0,13001
3,-98.36,-89.74,0,13001
3,-98.62,-90.03,0,13001
3,-98.91,-90.42,0,13001
3,-99.19,-90.85,0,13001
3,-99.39,-91.2,0,13001
3,-99.61,-91.64,0,13001
3,-99.79,-91.99,0,13001
3,-99.93,-92.38,0,13001
3,-100.07,-92.79,0,13001
3,-100.18,-93.25,0,13001
3,-100.25,-93.65,0,13001
3,-100.31,-94.15,0,13001
3,-100.33,-94.65,0,13001
3,-100.32,-95.03,0,13001
3,-100.3,-95.59,0,13001
3,-100.21,-96.1,0,13001
3,-100.12,-96.56,0,13001
3,-99.98,-97.08,0,13001
3,-99.82,-97.53,0,13001
3,-99.66,-97.93,0,13001
3,-99.42,-98.37,0,13001
3,-99.19,-98.74,0,13001
3,-98.9,-99.19,0,13001
3,-98.59,-99.6,0,13001
3,-98.18,-100.05,0,13001
3,-97.82,-100.41,0,13001
3,-97.54,-100.65,0,13001
3,-97.23,-100.91,0,13001
3,-97.05,-101.03,0,13001
3,-96.78,-101.21,0,13001
3,-96.51,-101.29,0,13001
3,-96.21,-101.46,0,13001
3,-95.97,-101.78,0,13001
3,-95.75,-101.97,0,13001
3,-95.51,-102.28,0,13001
3,-95.33,-102.54,0,13001
3,-95.18,-102.82,0,13001
3,-95.01,-103.2,0,13001
3,-94.9,-103.53,0,13001
3,-94.82,-103.87,0,13001
3,-94.77,-104.22,0,13001
3,-94.76,-104.59,0,13001
3,-94.75,-104.89,0,13001
3,-94.79,-105.13,0,13001
3,-94.86,-105.51,0,13001
3,-94.91,-105.82,0,13001
3,-95,-106.07,0,13001
3,-95.19,-106.52,0,13001
3,-95.36,-106.8,0,13001
3,-95.7,-107.22,0,13001
3,-96.08,-107.61,0,13001
3,-96.47,-107.91,0,13001
3,-96.78,-108.09,0,13001
3,-97.36,-108.37,0,13001
3,-98.01,-108.52,0,13001
3,-98.66,-108.62,0,13001
3,-99.27,-108.61,0,13001
3,-53.2,7.2,0,13001
3,-53.79,7.19,0,13001
3,-54.33,7.13,0,13001
3,-54.88,7.04,0,13001
3,-55.42,6.91,0,13001
3,-55.98,6.73,0,13001
3,-56.5,6.52,0,13001
3,-56.98,6.29,0,13001
3,-57.5,5.98,0,13001
3,-57.99,5.64,0,13001
3,-58.43,5.28,0,13001
3,-58.82,4.91,0,13001
3,-59.22,4.5,0,13001
3,-59.56,4.04,0,13001
3,-59.83,3.62,0,13001
3,-60.14,3.07,0,13001
3,-60.39,2.53,0,13001
3,-60.58,2.02,0,13001
3,-60.71,1.53,0,13001
3,-60.85,0.97,0,13001
3,-60.9,0.4,0,13001
3,-60.95,-0.2,0,13001
3,-60.91,-0.81,0,13001
3,-60.83,-1.46,0,13001
3,-60.72,-2.06,0,13001
3,-60.54,-2.7,0,13001
3,-60.23,-3.46,0,13001
3,-59.97,-3.96,0,13001
3,-59.67,-4.44,0,13001
3,-59.41,-4.93,0,13001
3,-59.25,-5.42,0,13001
3,-59.18,-6.01,0,13001
3,-59.15,-6.56,0,13001
3,-59.24,-7.14,0,13001
3,-59.39,-7.65,0,13001
3,-59.58,-8.13,0,13001
3,-59.58,-8.13,0,13001
3,-59.89,-8.6,0,13001
3,-60.24,-9.04,0,13001
3,-60.67,-9.37,0,13001
3,-61.06,-9.68,0,13001
3,-61.51,-9.91,0,13001
3,-62,-10.07,0,13001
3,-62.59,-10.22,0,13001
3,-63.15,-10.23,0,13001
3,-63.61,-10.2,0,13001
2,-92.79,-90.75,0,13001
2,-93.24,-90.79,0,13001
2,-93.58,-90.87,0,13001
2,-93.92,-90.95,0,13001
2,-94.24,-91.05,0,13001
2,-94.52,-91.15,0,13001
2,-94.74,-91.25,0,13001
2,-95.01,-91.39,0,13001
2,-95.29,-91.58,0,13001
2,-95.61,-91.86,0,13001
2,-95.84,-92.08,0,13001
2,-96.05,-92.35,0,13001
2,-96.25,-92.63,0,13001
2,-96.4,-92.88,0,13001
2,-96.56,-93.21,0,13001
2,-96.67,-93.49,0,13001
2,-96.77,-93.82,0,13001
2,-96.82,-94.14,0,13001
2,-96.86,-94.49,0,13001
2,-96.88,-94.84,0,13001
2,-96.86,-95.16,0,13001
2,-96.88,-95.49,0,13001
2,-96.75,-95.82,0,13001
2,-96.62,-96.21,0,13001
2,-96.48,-96.51,0,13001
2,-96.23,-96.97,0,13001
2,-95.93,-97.35,0,13001
2,-95.64,-97.68,0,13001
2,-95.23,-98.05,0,13001
2,-94.83,-98.31,0,13001
2,-94.46,-98.56,0,13001
2,-94.12,-98.84,0,13001
2,-93.77,-99.1,0,13001
2,-93.46,-99.35,0,13001
2,-93.19,-99.64,0,13001
2,-92.94,-99.94,0,13001
2,-92.67,-100.27,0,13001
2,-92.46,-100.58,0,13001
2,-92.26,-100.87,0,13001
2,-92.09,-101.22,0,13001
2,-91.92,-101.54,0,13001
2,-91.78,-101.9,0,13001
2,-91.59,-102.47,0,13001
2,-91.46,-102.96,0,13001
2,-91.36,-103.41,0,13001
2,-91.32,-103.85,0,13001
2,-91.27,-104.38,0,13001
2,-91.28,-104.91,0,13001
2,-91.32,-105.45,0,13001
2,-91.39,-105.96,0,13001
2,-91.5,-106.54,0,13001
2,-91.81,-107.5,0,13001
2,-92.17,-108.19,0,13001
2,-92.56,-108.84,0,13001
2,-92.86,-109.26,0,13001
2,-93.18,-109.65,0,13001
2,-93.47,-109.97,0,13001
2,-93.83,-110.29,0,13001
2,-94.15,-110.55,0,13001
2,-94.49,-110.78,0,13001
2,-94.93,-111.07,0,13001
2,-95.27,-111.25,0,13001
2,-95.67,-111.45,0,13001
2,-96.07,-111.63,0,13001
2,-96.48,-111.76,0,13001
2,-96.93,-111.89,0,13001
2,-97.39,-111.97,0,13001
2,-97.84,-112.05,0,13001
2,-98.39,-112.08,0,13001
2,-99.05,-112.11,0,13001
2,-53.28,3.68,0,13001
2,-53.93,3.64,0,13001
2,-54.49,3.53,0,13001
2,-55.25,3.25,0,13001
2,-55.72,2.96,0,13001
2,-56.21,2.56,0,13001
2,-56.67,2.08,0,13001
2,-57.01,1.51,0,13001
2,-57.25,0.94,0,13001
2,-57.4,0.34,0,13001
2,-57.46,-0.28,0,13001
2,-57.42,-0.93,0,13001
2,-57.26,-1.55,0,13001
2,-57.12,-1.91,0,13001
2,-56.82,-2.36,0,13001
2,-56.49,-2.94,0,13001
2,-56.24,-3.51,0,13001
2,-56.05,-4.01,0,13001
2,-55.88,-4.63,0,13001
2,-55.75,-5.16,0,13001
2,-55.71,-5.72,0,13001
2,-55.68,-6.31,0,13001
2,-55.67,-6.91,0,13001
2,-55.75,-7.51,0,13001
2,-55.85,-8.16,0,13001
2,-56.06,-8.81,0,13001
2,-56.3,-9.42,0,13001
2,-56.31,-9.42,0,13001
2,-56.54,-9.88,0,13001
2,-56.87,-10.39,0,13001
2,-57.16,-10.77,0,13001
2,-57.48,-11.18,0,13001
2,-57.87,-11.59,0,13001
2,-58.2,-11.9,0,13001
2,-58.69,-12.34,0,13001
2,-59.26,-12.7,0,13001
2,-59.79,-12.98,0,13001
2,-60.38,-13.22,0,13001
2,-61.02,-13.44,0,13001
2,-61.6,-13.58,0,13001
2,-63.01,-13.74,0,13001
2,-63.56,-13.71,0,13001
2,-64.16,-13.71,0,13001
1,-60.33,17.47,0,13003
3,-59.63,19.05,0,13003
3,-60.16,19.22,0,13003
3,-60.65,19.37,0,13003
3,-61.11,19.41,0,13003
3,-61.59,19.46,0,13003
3,-62.18,19.46,0,13003
3,-62.74,19.47,0,13003
3,-63.35,19.39,0,13003
3,-63.96,19.27,0,13003
3,-64.53,19.12,0,13003
3,-65.12,18.89,0,13003
3,-65.13,18.88,0,13003
3,-65.61,18.65,0,13003
3,-66.08,18.39,0,13003
3,-66.64,18.01,0,13003
3,-67.04,17.68,0,13003
3,-67.56,17.23,0,13003
3,-68.07,16.61,0,13003
3,-68.47,16.09,0,13003
3,-68.82,15.48,0,13003
3,-69.08,14.95,0,13003
3,-69.28,14.43,0,13003
3,-69.44,13.83,0,13003
3,-69.55,13.28,0,13003
3,-69.61,12.86,0,13003
3,-69.63,12.34,0,13003
3,-69.65,11.8,0,13003
3,-69.59,11.18,0,13003
3,-69.53,10.62,0,13003
3,-69.41,10.14,0,13003
3,-69.24,9.64,0,13003
3,-69.07,9.14,0,13003
3,-68.79,8.6,0,13003
3,-68.53,8.08,0,13003
3,-68.25,7.67,0,13003
3,-67.91,7.23,0,13003
3,-67.57,6.78,0,13003
3,-67.46,6.61,0,13003
3,-67.26,6.25,0,13003
3,-67.07,5.77,0,13003
3,-66.92,5.23,0,13003
3,-66.86,4.7,0,13003
3,-66.86,4.18,0,13003
3,-66.9,3.68,0,13003
3,-67,3.34,0,13003
3,-67.16,2.88,0,13003
3,-67.42,2.38,0,13003
3,-67.74,1.94,0,13003
3,-68.12,1.53,0,13003
3,-68.53,1.16,0,13003
3,-68.94,0.86,0,13003
3,-69.42,0.65,0,13003
3,-70.08,0.47,0,13003
2,-60.94,15.83,0,13003
2,-61.39,15.95,0,13003
2,-61.76,16.01,0,13003
2,-62.28,16.03,0,13003
2,-62.8,16,0,13003
2,-63.32,15.89,0,13003
2,-63.82,15.69,0,13003
2,-64.29,15.4,0,13003
2,-64.75,15.1,0,13003
2,-65.14,14.73,0,13003
2,-65.51,14.27,0,13003
2,-65.79,13.78,0,13003
2,-66.01,13.26,0,13003
2,-66.14,12.72,0,13003
2,-66.17,12.23,0,13003
2,-66.15,11.66,0,13003
2,-66.06,11.08,0,13003
2,-65.89,10.55,0,13003
2,-65.67,10.06,0,13003
2,-65.35,9.65,0,13003
2,-65.01,9.2,0,13003
2,-64.64,8.75,0,13003
2,-64.41,8.33,0,13003
2,-64.17,7.89,0,13003
2,-63.96,7.43,0,13003
2,-63.79,7.02,0,13003
2,-63.62,6.55,0,13003
2,-63.51,6.03,0,13003
2,-63.44,5.47,0,13003
2,-63.39,4.89,0,13003
2,-63.38,4.3,0,13003
2,-63.4,3.68,0,13003
2,-63.48,3.14,0,13003
2,-63.57,2.6,0,13003
2,-63.79,1.99,0,13003
2,-64.02,1.41,0,13003
2,-64.3,0.84,0,13003
2,-64.61,0.34,0,13003
2,-64.93,-0.12,0,13003
2,-65.26,-0.52,0,13003
2,-65.67,-0.94,0,13003
2,-66.17,-1.39,0,13003
2,-66.75,-1.8,0,13003
2,-67.29,-2.15,0,13003
2,-67.82,-2.4,0,13003
2,-68.39,-2.59,0,13003
2,-68.91,-2.76,0,13003
2,-69.57,-2.92,0,13003
2,-105.77,-108.37,0,14001
1,-106.61,-110.55,0,14001
1,-106.85,-111.91,0,14001
1,-113.56,-111.53,0,14001
1,-113.88,-117.72,0,14001
2,-117.48,-117.53,0,14001
2,-116.97,-107.7,0,14001
2,-75.32,-10.76,0,14002
1,-75.26,-12.66,0,14002
1,-75.1,-14.33,0,14002
1,-80.47,-14.7,0,14002
1,-80.18,-20.07,0,14002
2,-83.76,-20.3,0,14002
2,-84.27,-11.34,0,14002
2,-88.7,-1.35,0,14003
1,-88.68,-3.17,0,14003
1,-88.52,-4.96,0,14003
1,-93.68,-5.52,0,14003
1,-93.13,-10.88,0,14003
2,-96.67,-11.24,0,14003
2,-97.62,-2.34,0,14003
1,-87.4,-119.19,0,15001
1,-74.2,-110.8,0,15001
1,-75.74,-108.31,0,15001
1,-75.45,-108.14,0,15001
1,-73.93,-110.63,0,15001
1,-73.53,-110.37,0,15001
1,-85.47,-122.88,0,15002
1,-72.06,-114.27,0,15002
1,-73.57,-111.77,0,15002
1,-73.35,-111.63,0,15002
1,-71.77,-114.11,0,15002
1,-71.34,-113.84,0,15002
1,-37.92,-7.91,0,15003
1,-27.39,-1.06,0,15003
1,-28.86,1.31,0,15003
1,-28.6,1.48,0,15003
1,-27.11,-0.88,0,15003
1,-26.71,-0.61,0,15003
1,-35.7,-11.16,0,15004
1,-25.13,-4.34,0,15004
1,-26.43,-2.05,0,15004
1,-26.18,-1.88,0,15004
1,-24.9,-4.16,0,15004
1,-24.51,-3.9,0,15004
1,-111.09,-140.27,0,91001
1,-111.63,-138.68,0,91001
1,-97.2,-129.4,0,91001
1,-96.15,-130.59,0,91001
1,-95.78,-130.35,0,91002
1,-96.32,-129.67,0,91002
1,-85.41,-123.27,0,91002
1,-85.15,-123.73,0,91002
1,-85.11,-123.7,0,91003
1,-85.17,-123.15,0,91003
1,-71.19,-114.08,0,91003
1,-68.08,-112.04,0,91003
1,-66.64,-111,0,91003
1,-53.13,-102.36,0,91003
1,-50.63,-100.72,0,91003
1,-50.26,-101.38,0,91003
1,-50.17,-101.22,0,91004
1,-50.43,-100.47,0,91004
1,-28.32,-86.57,0,91004
1,-28.14,-87.22,0,91004
1,-27.84,-86.3,0,91005
1,-28.24,-86.75,0,91005
1,-52.47,-49.86,0,91005
1,-51.71,-49.32,0,91005
1,-52.28,-48.27,0,91006
1,-51.99,-48.9,0,91006
1,-129.23,-98.45,0,91006
1,-129.74,-97.62,0,91006
1,-130.14,-98.53,0,91007
1,-129.68,-98.44,0,91007
1,-111.79,-138.61,0,91007
1,-112.27,-138.79,0,91007
1,-87.23,-120.29,0,91008
1,-87.51,-119.65,0,91008
1,-73.25,-110.56,0,91008
1,-69.06,-107.78,0,91008
1,-66.81,-106.27,0,91008
1,-52.83,-97.26,0,91008
1,-52.28,-97.9,0,91008
1,-54.32,-94.46,0,91009
1,-54.92,-93.55,0,91009
1,-56.12,-93.5,0,91009
1,-90.45,-115.66,0,91009
1,-89.88,-117.08,0,91009
1,17.58,33.42,0,91010
1,3.09,24.1,0,91010
1,2.85,24.01,0,91010
1,2.49,24.01,0,91010
1,-4.04,24.16,0,91010
1,-4.38,24.1,0,91010
1,-4.74,23.9,0,91010
1,-19.99,14.04,0,91010
1,-25.95,10.41,0,91010
1,-47.45,-3.55,0,91010
1,-52.84,-13.44,0,91010
1,-53.01,-13.67,0,91010
1,-53.19,-13.85,0,91010
1,-54.6,-14.8,0,91010
1,-54.81,-14.93,0,91010
1,-68.36,-21.63,0,91010
1,-68.66,-21.73,0,91010
1,-69.11,-21.85,0,91010
1,-78,-24.1,0,91010
1,-77.97,-28.11,0,91011
1,-65.52,-30.1,0,91011
1,-65.14,-30.13,0,91011
1,-64.86,-30.12,0,91011
1,-64.49,-29.98,0,91011
1,-45.56,-17.6,0,91011
1,-37.92,-1.26,0,91012
1,-25.45,6.81,0,91012
1,-25.07,7.01,0,91012
1,-24.46,7.36,0,91012
1,-6.21,17.31,0,91012
1,-1.59,10.43,0,91013
1,12.26,16.46,0,91013
1,28.09,22.9,0,91013
1,37.12,25.87,0,91013
1,28.11,50.54,0,91013
1,20.26,72.01,0,91013
1,14.05,70.85,0,91013
1,13.74,70.76,0,91013
1,13.43,70.56,0,91013
1,-0.11,61.82,0,91013
1,6.76,50.33,0,91014
1,-8.34,40.66,0,91014
1,-6.16,37.15,0,91015
1,9.01,46.88,0,91015
1,-19.49,43.31,0,91016
1,-23.92,40.45,0,91016
1,-30.57,34.53,0,91016
1,-32.23,32.66,0,91016
1,-35.9,35.47,0,91017
1,-30.75,41.6,0,91017
1,-30.51,41.9,0,91017
1,-30.09,42.21,0,91017
1,-16.16,51.41,0,91017
1,-23.7,19.84,0,91018
1,-10.05,28.72,0,91018
1,2.01,25.1,0,91019
1,-5.18,25.28,0,91019
1,-5.38,25.26,0,91019
1,-5.65,25.13,0,91019
1,-20.77,15.34,0,91019
1,-21.55,14.81,0,91019
1,-25.74,12.06,0,91019
1,-39.45,2.83,0,91020
1,-39.36,2.74,0,91020
1,-46.65,-2.08,0,91020
1,-46.85,-1.99,0,91020
1,12.25,41.79,0,91021
1,9.24,46.54,0,91021
1,-5.93,36.84,0,91021
1,-2.89,32.08,0,91021
1,3.03,35.87,0,91021
1,0.27,40.25,0,91021
1,3.86,42.52,0,91021
1,6.73,38.22,0,91021
1,17.41,33.74,0,91022
1,16.9,34.55,0,91022
1,2.14,25.1,0,91022
1,2.66,24.26,0,91022
1,-4.94,25.12,0,91023
1,-4.53,24.47,0,91023
1,-20.56,15.05,0,91023
1,-20.15,14.39,0,91023
1,-26.11,10.8,0,91024
1,-26.43,11.26,0,91024
1,-39.31,2.91,0,91024
1,-39.01,2.43,0,91024
1,-42.08,7.14,0,91025
1,-43.94,9.97,0,91025
1,-38.02,9.78,0,91025
1,-39.34,11.92,0,91025
1,-31.34,17.18,0,91025
1,-29.99,15.03,0,91025
1,-29.18,15.54,0,91025
1,-31.04,18.44,0,91025
1,-24.69,21.44,0,91026
1,-23.91,20.2,0,91026
1,-10.23,29.06,0,91026
1,-10.96,30.2,0,91026
1,-0.55,61.87,0,91027
1,2.45,57.16,0,91027
1,-3.16,53.52,0,91027
1,-6.2,58.16,0,91027
1,-9.63,55.99,0,91027
1,-9.77,55.77,0,91027
1,-6.84,51.21,0,91027
1,-12.79,47.37,0,91027
1,-15.82,52.12,0,91027
1,-16.22,52.76,0,91028
1,-16.17,51.9,0,91028
1,-31.11,42.12,0,91028
1,-39.53,31.55,0,91028
1,-40.5,30.96,0,91028
1,-41.79,33.03,0,91028
1,-49.83,27.83,0,91028
1,-48.51,25.74,0,91028
1,-58.45,19.27,0,91028
1,-59.83,19.81,0,91028
1,-61.18,20.06,0,91028
1,-63.02,20.06,0,91028
1,-64.21,19.85,0,91028
1,-65.27,19.53,0,91028
1,-67.15,18.49,0,91028
1,-67.83,17.94,0,91028
1,-68.52,17.12,0,91028
1,-69.12,16.27,0,91028
1,-69.63,15.19,0,91028
1,-70.19,13.52,0,91028
1,-70.33,12.19,0,91028
1,-70.22,10.57,0,91028
1,-69.93,9.48,0,91028
1,-69.16,7.76,0,91028
1,-68.59,6.96,0,91028
1,-67.95,6.15,0,91028
1,-67.63,5.26,0,91028
1,-67.52,4.32,0,91028
1,-67.74,3.23,0,91028
1,-68.17,2.43,0,91028
1,-68.88,1.73,0,91028
1,-70.24,1.11,0,91028
1,-79.29,0.27,0,91028
1,-98.84,-1.82,0,91028
1,-98.96,-1.62,0,91028
1,-99.99,-2.22,0,91028
1,-100.32,-1.61,0,91028
1,-99.92,-2.37,0,91029
1,-97.18,-10.91,0,91029
1,-97.28,-12.37,0,91029
1,-96.38,-15.72,0,91029
1,-95.46,-17.36,0,91029
1,-93.64,-19.08,0,91029
1,-91.2,-20.22,0,91029
1,-89,-22.57,0,91029
1,-88,-23.71,0,91029
1,-87.06,-24.66,0,91029
1,-84.97,-26.18,0,91029
1,-82.79,-27.33,0,91029
1,-79.72,-28.23,0,91029
1,-64.82,-30.69,0,91029
1,-51.63,-22.05,0,91029
1,-51.54,-22.74,0,91029
1,-44.31,-19.37,0,91030
1,-44.78,-19.65,0,91030
1,-45.1,-18.14,0,91030
1,-41.04,-15.45,0,91031
1,-40.6,-15.07,0,91031
1,-40.1,-16.25,0,91031
1,-40.43,-16.63,0,91031
1,-47.09,-2.1,0,91032
1,-50.29,3.19,0,91032
1,-53.59,3.05,0,91032
1,-54.56,2.87,0,91032
1,-55.41,2.44,0,91032
1,-56.03,1.9,0,91032
1,-56.46,1.25,0,91032
1,-56.77,0.27,0,91032
1,-56.82,-0.73,0,91032
1,-56.53,-1.7,0,91032
1,-55.94,-2.61,0,91032
1,-55.43,-3.87,0,91032
1,-55.07,-5.24,0,91032
1,-55,-6.44,0,91032
1,-55.13,-7.53,0,91032
1,-55.37,-8.6,0,91032
1,-55.72,-9.6,0,91032
1,-56.28,-10.51,0,91032
1,-56.99,-11.52,0,91032
1,-57.62,-12.27,0,91032
1,-58.45,-12.91,0,91032
1,-58.98,-13.39,0,91032
1,-60.36,-14.02,0,91032
1,-61.88,-14.37,0,91032
1,-62.71,-14.51,0,91032
1,-64,-14.43,0,91032
1,-64.88,-14.29,0,91032
1,-67.01,-14.96,0,91032
1,-79.02,-15.84,0,91032
1,-78.07,-23.7,0,91032
1,-69.03,-21.38,0,91032
1,-68.17,-21.05,0,91032
1,-55.48,-14.7,0,91032
1,-53.34,-13.4,0,91032
1,-53.19,7.9,0,91033
1,-61.08,15.21,0,91033
1,-62.28,15.37,0,91033
1,-63.17,15.24,0,91033
1,-64.18,14.74,0,91033
1,-64.81,14.14,0,91033
1,-65.23,13.5,0,91033
1,-65.52,12.73,0,91033
1,-65.57,11.71,0,91033
1,-65.34,10.72,0,91033
1,-64.76,9.84,0,91033
1,-63.66,8.23,0,91033
1,-63.06,6.72,0,91033
1,-62.76,4.98,0,91033
1,-62.83,3.27,0,91033
1,-63.15,1.96,0,91033
1,-63.74,0.52,0,91033
1,-64.63,-0.76,0,91033
1,-65.66,-1.83,0,91033
1,-67.41,-2.94,0,91033
1,-69.4,-3.59,0,91033
1,-75.08,-4.26,0,91033
1,-90.09,-6.43,0,91033
1,-91.85,-7.54,0,91033
1,-92.07,-10.54,0,91033
1,-92.39,-12.94,0,91033
1,-91.57,-14.87,0,91033
1,-90.64,-15.51,0,91033
1,-89.43,-15.85,0,91033
1,-87.99,-15.72,0,91033
1,-87.12,-15.35,0,91033
1,-85.29,-13.62,0,91033
1,-84.91,-13.17,0,91033
1,-84.89,-10.55,0,91033
1,-73.71,-9.8,0,91033
1,-66.21,-9.4,0,91033
1,-63.44,-9.6,0,91033
1,-62.51,-9.58,0,91033
1,-61.52,-9.26,0,91033
1,-60.82,-8.62,0,91033
1,-59.93,-7.28,0,91033
1,-59.71,-6.44,0,91033
1,-59.89,-5.45,0,91033
1,-60.47,-4.33,0,91033
1,-60.92,-3.57,0,91033
1,-61.33,-2.44,0,91033
1,-61.51,-1.26,0,91033
1,-61.55,-0.01,0,91033
1,-61.4,1.28,0,91033
1,-61.08,2.5,0,91033
1,-60.56,3.64,0,91033
1,-59.56,5.11,0,91033
1,-58.64,5.95,0,91033
1,-57.64,6.66,0,91033
1,-56.49,7.23,0,91033
1,-55.32,7.61,0,91033
1,-54.27,7.82,0,91033
1,-46.79,14.39,0,91034
1,-42.67,17.11,0,91034
1,-43.96,19.24,0,91034
1,-36.13,24.32,0,91034
1,-34.79,22.23,0,91034
1,-33.92,22.76,0,91034
1,-36.8,27.26,0,91034
1,-49.69,18.82,0,91034
1,-29.42,28.6,0,91035
1,-23.73,32.25,0,91035
1,-26.4,36.47,0,91035
1,-22.85,38.81,0,91035
1,-20.05,34.64,0,91035
1,-20,34.62,0,91035
1,-15.71,37.44,0,91035
1,-19.3,42.99,0,91035
1,-23.69,40.15,0,91035
1,-30.31,34.25,0,91035
1,-31.95,32.4,0,91035
1,-5.86,16.56,0,91036
1,-6.14,16.92,0,91036
1,-18.97,8.67,0,91036
1,-24.93,6.72,0,91036
1,-37.72,-1.58,0,91036
1,-36.89,-2.94,0,91036
1,-39.94,-4.92,0,91036
1,-39.66,-5.31,0,91036
1,-40.28,-15.19,0,91037
1,-35.29,-11.95,0,91037
1,-35.47,-11.56,0,91037
1,-23.27,-3.62,0,91037
1,-18.8,-0.67,0,91037
1,-2.01,10.12,0,91037
1,-1.79,9.82,0,91037
1,-1.17,9.79,0,91038
1,27.13,20.23,0,91038
1,26.94,21.26,0,91038
1,28.66,22.26,0,91038
1,30.5,22.92,0,91038
1,37.61,25.68,0,91038
1,34.31,34.69,0,91038
1,34.4,42.1,0,91038
1,28.73,58.41,0,91038
1,27.83,58.27,0,91038
1,27.41,59.6,0,91038
1,22.54,72.4,0,91038
1,-37.47,-8.6,0,91039
1,-37.66,-8.31,0,91039
1,-25.58,-0.46,0,91039
1,-4.07,13.44,0,91039
1,-3.86,13.18,0,91039
1,-3.86,13.19,0,91039
`;
}